import { useMemo } from "react";
import { router } from "react-query-kit";
import {
  deleteRequestPath,
  getRequest,
  postRequest,
  QueryParams,
  useBaseUrl,
  useInvalidate
} from "@services/api/requests.service";
import {
  FetchedAuthenticationConfigProps,
  FetchedAuthenticationProps,
  FetchedLogoutProps
} from "@src/types/auth.types";

export default function useAuthApi() {
  const baseUrl = useBaseUrl("");

  const AuthApi = useMemo(
    () =>
      router("auth", {
        current: router.query({
          fetcher: (queryParams: QueryParams) =>
            getRequest<FetchedAuthenticationProps | undefined>(
              `${baseUrl}/authentication/current`,
              queryParams
            )
        }),

        config: router.query({
          fetcher: (queryParams: QueryParams) =>
            getRequest<FetchedAuthenticationConfigProps | undefined>(
              `${baseUrl}/authentication/config`,
              queryParams
            )
        }),

        token: router.mutation({
          mutationFn: (token: string) =>
            postRequest<FetchedAuthenticationProps | undefined>(
              `${baseUrl}/token/authenticate`,
              {
                token,
                logoutUrl: "/token?action=logout"
              }
            )
        }),

        remove: router.mutation({
          mutationFn: () =>
            deleteRequestPath<FetchedLogoutProps>(`${baseUrl}/authentication`)
        })
      }),
    [baseUrl]
  );

  const invalidate = useInvalidate(AuthApi);

  return {
    useCurrentApi: AuthApi.current.useQuery,
    useRemoveMutation: AuthApi.remove.useMutation,
    useTokenMutation: AuthApi.token.useMutation,
    useConfigApi: AuthApi.config.useQuery,
    invalidate
  };
}
